<template>
    <span :style="{ height: displayHeight, width: displayWidth}" class="skeleton max-w-full" :class="{rounded: props.rounded}"/>
</template>

<script setup lang="ts">
    import {formatDimension} from "@spoferan/spoferan-ts-core";

	const props = withDefaults(defineProps<{
		rounded?: boolean,

		// The fixed width of the skeleton in pixels
		width?: string | number,

		// The height of the skeleton
		// Defaults to the height of a paragraph
		height?: string | number,
	}>(), {
		rounded: false,
		width: 80,
		height: '16px',
	});

	const displayWidth = formatDimension(props.width);
	const displayHeight = formatDimension(props.height);

</script>

<style>
.skeleton {
  display: block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  background-color: #DDDBDD;
}
.skeleton::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 5s infinite;
  content: "";
}
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>